"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockFlags = void 0;
const useFlags_1 = require("@hum/icm-app/src/hooks/useFlags");
/* mockFlags
 * provide mock feature flags to a test
 */
const mockFlags = (flags) => {
    useFlags_1.useFlags.mockImplementation(() => {
        const get = jest.fn(() => flags);
        const enabled = jest.fn((flagNames) => {
            var _a;
            if (typeof flagNames === 'string') {
                return (_a = get()[flagNames]) === null || _a === void 0 ? void 0 : _a.enabled;
            }
            else {
                const mockedFlags = get();
                return flagNames.map((flag) => mockedFlags[flag].enabled);
            }
        });
        return { get, enabled, ready: true };
    });
};
exports.mockFlags = mockFlags;
//# sourceMappingURL=mockFlags.js.map